import { ArrowLeftOutlined, HomeFilled, LogoutOutlined } from "@ant-design/icons";
import { Button, Result } from "antd";
import { Link, useNavigate, useRouteError } from "react-router-dom";
import RoutePath from "../../app/routing/routes.path";

export function ErrorBoundary( ) {
    let error:any = useRouteError();
    const navigate = useNavigate();
    console.error(error);
    let unauthorized = error?.response?.status == 401;
    return <Result
        status={error.status || '500'}
        title={error.statusText || error.message || "Unknown Error"}
        subTitle={error.error && error.error.toString()|| error?.response?.data?.message || "Contact Developer"}
        extra={[
          <Link to=""><Button key="buy" icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)}>Go back</Button></Link>,
          unauthorized ?
            (<Link to={RoutePath.login}><Button type="primary" key="console" icon={<LogoutOutlined />}>
              Go to Login
            </Button></Link>) :
            (<Link to="/"><Button type="primary" key="console" icon={<HomeFilled />}>
              Go to Home
            </Button></Link>)
        ]}
    />;
}